<template>
    <div>
        <!--edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-user-page-heading">
                    <h3 class="fw-bold">{{ Usuario.cusId ? 'Alterar usuário' : 'Novo usuário' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Usuários</a>
                        </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><span>{{ Usuario.cusId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="gp-user-form-header">
                                <span class="gp-user-form-icon"><v-icon size="20">mdi-account-cog-outline</v-icon></span>
                                <div><h4>{{ Usuario.cusId ? 'Alterar usuário' : 'Novo usuário' }}</h4><p>Informe os dados de acesso, contato e vínculo do usuário.</p></div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="Usuario.cusId" type="text" class="form-control"
                                                placeholder="Id" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="TipoPessoas != '' && User!='' && User.garid == 0">
                                        <div class="form-group">
                                            <label>Tipo Pessoa</label>
                                            <select v-model="Usuario.tpeId" class="form-select form-control" id="defaultSelect" @change="TipoPessoaSelected()">
                                                <option :value="null">Selecione</option>
                                                <option v-for="optionTipo in TipoPessoas" :key="optionTipo.tpeId"
                                                    :value="optionTipo.tpeId">{{ optionTipo.tpeNome }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="User!= '' && Usuario.tpeId != '' && Usuario.tpeId != null && User.garid == 0">
                                        <div class="form-group">
                                            <label>Garantidora</label>
                                            <v-autocomplete v-model="Usuario.garId" :items="garantidorasFormularioUsuario"
                                                item-title="garNomeEmpresa" item-value="garId" density="compact"
                                                variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                no-data-text="Nenhuma garantidora encontrada" :disabled="User.tpeid === 1"
                                                @update:model-value="Usuario.pesId = null; BuscaImobiliarias()" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="Usuario.tpeId != '' && Usuario.tpeId != null && (Usuario.tpeId == 2)" v-show="false">
                                        <div class="form-group">
                                            <label>Parceiro</label>
                                            <select  v-model="Usuario.pesId" class="form-select form-control" :disabled="User.tpeid === 1 || User.tpeid === 2">
                                                <option :value=null>Selecione</option>
                                                <option v-for="optionTipo in ListParceirosGeral" :key="optionTipo.parId"
                                                    :value="optionTipo.parId">{{ optionTipo.parNomeEmpresa }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="User.garid==0 && Usuario.tpeId != null && (Usuario.tpeId == 3)">
                                        <div class="form-group">
                                            <label>Imobiliaria</label>
                                            <v-autocomplete v-model="Usuario.pesId" :items="imobiliariasFormularioUsuario"
                                                item-title="imoNomeEmpresa" item-value="imoId" density="compact"
                                                variant="outlined" :disabled="!Usuario.garId || User.tpeid === 3 || User.tpeid === 2"
                                                :placeholder="Usuario.garId ? 'Digite para pesquisar' : 'Selecione a garantidora'"
                                                clearable hide-details no-data-text="Nenhuma imobiliária encontrada" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Perfil Usuário</label>
                                            <select  v-model="Usuario.admTipoUsuario.tusId" class="form-select form-control">
                                                <option :value=null>Selecione</option>
                                                <option v-for="optionTipo in TipoUsuario" :key="optionTipo.tusId"
                                                    :value="optionTipo.tusId">{{ optionTipo.tusNome }}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Nome</label>
                                            <input v-model="Usuario.cusNome" type="text" class="form-control"
                                                placeholder="Nome" />
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-lg-5">
                                        <div class="form-group">
                                            <label>E-mail</label>
                                            <input v-model="Usuario.cusEmail" type="text" class="form-control"
                                                placeholder="E-mail" />
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Senha</label>
                                            <div class="input-icon">
                                                <input v-model="Usuario.cusSenha"
                                                    :type="senhaVisivel ? 'text' : 'password'" class="form-control"
                                                    placeholder="Senha" />
                                                <span class="input-icon-addon">
                                                    <i @click="toggleSenhaVisivel()"
                                                        :class="senhaVisivel ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Telefone</label>
                                            <input v-model="Usuario.cusTelefone" v-mask="'(##) ####-#####'" type="text"
                                                class="form-control" placeholder="Telefone" />
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Whatsapp</label>
                                            <input v-model="Usuario.cusWhatsapp" v-mask="'(##) ####-#####'" type="text"
                                                class="form-control" placeholder="Whatsapp" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <div class="form-group">
                                            <label>Ativo</label>
                                            <select v-model="Usuario.cusAtivo" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label for="exampleFormControlFile1">Upload da Imagem</label>
                                            <v-file-input v-model="selectedFile" label="Imagem" variant="underlined"
                                                prepend-icon="mdi-account-circle" accept="image/*"></v-file-input>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2" v-if="Usuario.cusUrlImagem !== '' && Usuario.cusUrlImagem !== null">
                                        <div class="form-group">
                                            <AuthenticatedImage :path="Usuario.cusUrlImagem || ''" endpoint="/Telas/CadastroUsuarios/GetFileByParam" fallback="/images/userNo.png" alt="Foto do usuário" style="width: 100px" />
                                            <v-btn icon density="compact" color="red" class="delete-icon"
                                                variant="text">
                                                <v-icon @click="DeleteImagem()"
                                                    style="font-size:22px;">mdi-alpha-x-circle</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-user-main-actions gp-detail-actions">
                        <button v-if="Usuario.cusId != 0" type="button" class="btn btn-success" style="color:#ffffff;"
                            @click="Put()">
                            <v-icon size="16">mdi-content-save-outline</v-icon> Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            <v-icon size="16">mdi-content-save-outline</v-icon> Salvar
                        </button>
                        <a href="#" @click="EditCancel()" class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de usuários</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body" v-if="ListGarantidorasGeral!=''">
                                <div class="gp-user-filters">
                                    <div v-if="User.garid == 0" class="gp-user-filter gp-filter-3"><label>Garantidora</label><v-autocomplete v-model="filtroGarantidora" :items="garantidorasFiltro" item-title="garNomeEmpresa" item-value="garId" density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details no-data-text="Nenhuma garantidora encontrada" @update:model-value="filtroImobiliaria = null" /></div>
                                    <div class="gp-user-filter gp-filter-3"><label>Imobiliária</label><v-autocomplete v-model="filtroImobiliaria" :items="imobiliariasFiltro" item-title="imoNomeEmpresa" item-value="imoId" density="compact" variant="outlined" :disabled="ehImobiliaria || !filtroGarantidora" :placeholder="filtroGarantidora ? 'Digite para pesquisar' : 'Selecione a garantidora'" clearable hide-details no-data-text="Nenhuma imobiliária encontrada" /></div>
                                    <div class="gp-user-filter gp-filter-3"><label>Nome</label><input v-model.trim="filtroNome" class="form-control" type="text" placeholder="Nome do usuário" /></div>
                                    <div class="gp-user-filter gp-filter-3"><label>E-mail</label><input v-model.trim="filtroEmail" class="form-control" type="text" placeholder="E-mail" /></div>
                                    <div class="gp-user-filter gp-filter-3"><label>WhatsApp</label><input v-model.trim="filtroWhatsapp" v-mask="'(##) ####-#####'" class="form-control" type="text" placeholder="(00) 00000-0000" /></div>
                                    <button type="button" class="btn btn-outline-secondary gp-user-clear gp-filter-3" @click="limparFiltros"><i class="fas fa-eraser"></i> Limpar</button>
                                </div>
                                <div class="gp-user-grid-toolbar"><div>{{ usuariosFiltrados.length }} usuário(s) encontrado(s)</div><button type="button" class="btn gp-export-button" :disabled="!usuariosFiltrados.length" @click="exportarUsuariosExcel"><v-icon size="16">mdi-microsoft-excel</v-icon> Exportar Excel</button></div>
                                <garante-pay-data-table :headers="headers" :items="usuariosFiltrados" v-model="itemsSelected"
                                    alternating theme-color="#364f66" table-class-name="customize-table"
                                    header-text-direction="center" body-text-direction="center"
                                    rows-per-page-message="Linhas por pagina">
                                    <template #item-cusUrlImagem="item">
                                        <AuthenticatedImage :path="item.cusUrlImagem || ''" endpoint="/Telas/CadastroUsuarios/GetFileByParam" fallback="/images/userNo.png" alt="Foto do usuário"
                                            style="width: 40px;height:auto;border-radius:50px" />
                                    </template>
                                    <template #item-cusAtivo="item">
                                        <span class="gp-user-status" :class="item.cusAtivo ? 'is-active' : 'is-inactive'">{{ item.cusAtivo ? 'Ativo' : 'Inativo' }}</span>
                                    </template>
                                    <template #item-cusDtCadastro="item">
                                        <span>{{ formattedDate(item.cusDtCadastro) }}</span>
                                    </template>
                                    <template #item-garId="item">
                                        <span>{{ nomeAcesso(item) }}</span>
                                    </template>
                                    <template #item-pesId="item">
                                        <span>{{ nomeImobiliaria(item) }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <div class="gp-table-actions"><button type="button" class="gp-table-action gp-action-edit" title="Editar" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button></div>
                                        <!--v-btn v-if="User.garid == 0" icon @click="DeleteGrid(item)" variant="text">
                                            <v-icon class="deliconcor">mdi-delete-forever</v-icon>
                                            <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                                        </!--v-btn-->
                                    </template>
                                </garante-pay-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import AuthenticatedImage from '../../components/AuthenticatedImage.vue'
import { personalizarEmailGarantidora } from '../../utils/guarantorEmail'
import moment from 'moment'
import { useRoute } from 'vue-router'

export default {
  name: 'CadastroUsuariosView',
  components: {
    AuthenticatedImage,
    moment
  },
  setup () {
    const route = useRoute()
    const id = route.params.id

    return {
      id
    }
  },
  data: () => ({
    EditView: false,
    ListGarantidorasGeral: [],
    ListGarantidoras: [],
    ListImobiliariasGeral: [],
    ListParceirosGeral: [],
    User: {
      garid: 0,
      tpeid: 0,
      tusid: 0,
      pesid: 0
    },
    Usuario: {
      cusId: 0,
      cusNome: '',
      cusEmail: '',
      cusTelefone: '',
      cusWhatsapp: '',
      cusSenha: '',
      cusDtCadastro: null,
      tusId: '',
      cusAtivo: '',
      cusUrlImagem: '',
      cliId: null,
      admTipoUsuario: { tusId: '' },
      tpeId: null,
      garId: null,
      pesId: null
    },
    Usuarios: [],
    TipoUsuario: [],
    headers: [
      { text: 'Id', value: 'cusId', sortable: true },
      { text: 'Imagem', value: 'cusUrlImagem' },
      { text: 'Garantidora', value: 'garId' },
      { text: 'Imobiliária', value: 'pesId' },
      { text: 'Nome', value: 'cusNome', sortable: true },
      { text: 'Email', value: 'cusEmail', sortable: true },
      { text: 'Whatsapp', value: 'cusWhatsapp' },
      { text: 'Data Cadastro', value: 'cusDtCadastro' },
      { text: 'Tipo', value: 'admTipoUsuario.tusNome', sortable: true },
      { text: 'Ativo', value: 'cusAtivo', sortable: true },
      { text: 'Ações', value: 'actions' }
    ],
    searchValue: '',
    itemsSelected: null,
    filtroGarantidora: null,
    filtroImobiliaria: null,
    filtroNome: '',
    filtroEmail: '',
    filtroWhatsapp: '',
    ListaImobiliariasFiltro: [],
    senhaVisivel: false,
    selectedFile: null,
    ListImobiliarias: [],
    ImobSelected: [],
    showCli: false,
    lblcli: '',
    ListImobiliariasGeral: []
  }),
  computed: {
    ehImobiliaria () { return Number(this.User.tpeid) === 3 },
    garantidorasFiltro () {
      return [...this.ListGarantidorasGeral].sort((a, b) => (a.garNomeEmpresa || '').localeCompare(b.garNomeEmpresa || '', 'pt-BR'))
    },
    garantidorasFormularioUsuario () {
      return [...this.ListGarantidoras].sort((a, b) => (a.garNomeEmpresa || '').localeCompare(b.garNomeEmpresa || '', 'pt-BR'))
    },
    imobiliariasFormularioUsuario () {
      if (!this.Usuario.garId) return []
      return this.ListImobiliariasGeral.filter(item => !this.ehImobiliaria || (Number(item.imoId) === Number(this.User.pesid) && Number(item.garId) === Number(this.User.garid))).sort((a, b) => (a.imoNomeEmpresa || '').localeCompare(b.imoNomeEmpresa || '', 'pt-BR'))
    },
    imobiliariasFiltro () {
      if (!this.filtroGarantidora) return []
      return this.ListaImobiliariasFiltro.filter(item => item.garId == this.filtroGarantidora &&
        (!this.ehImobiliaria || Number(item.imoId) === Number(this.User.pesid)))
        .sort((a, b) => (a.imoNomeEmpresa || '').localeCompare(b.imoNomeEmpresa || '', 'pt-BR'))
    },
    usuariosFiltrados () {
      const nome = this.normalizar(this.filtroNome); const email = this.normalizar(this.filtroEmail)
      const whatsapp = String(this.filtroWhatsapp || '').replace(/\D/g, '')
      return this.Usuarios.filter(item => {
        return (!this.ehImobiliaria || (Number(item.tpeId) === 3 && Number(item.pesId) === Number(this.User.pesid) && Number(item.garId) === Number(this.User.garid))) &&
                    (!this.filtroGarantidora || item.garId == this.filtroGarantidora) &&
                    (!this.filtroImobiliaria || item.pesId == this.filtroImobiliaria) &&
                    (!nome || this.normalizar(item.cusNome).includes(nome)) &&
                    (!email || this.normalizar(item.cusEmail).includes(email)) &&
                    (!whatsapp || String(item.cusWhatsapp || '').replace(/\D/g, '').includes(whatsapp))
      })
    }
  },
  methods: {
    normalizar (value) {
      return String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    },
    nomeAcesso (item) {
      if (item.garId === null || item.garId === 0) return 'GarantePay'
      return this.ListGarantidorasGeral.find(x => x.garId == item.garId)?.garNomeEmpresa || '—'
    },
    nomeImobiliaria (item) {
      if (item.tpeId != 3) return '—'
      return this.ListaImobiliariasFiltro.find(x => x.imoId == item.pesId)?.imoNomeEmpresa || '—'
    },
    limparFiltros () {
      this.filtroGarantidora = this.User.garid || null
      this.filtroImobiliaria = this.ehImobiliaria ? this.User.pesid : null
      this.filtroNome = ''
      this.filtroEmail = ''
      this.filtroWhatsapp = ''
    },
    formattedDate (value) {
      return this.$moment(value).format('DD/MM/YYYY')
    },
    toggleSenhaVisivel () {
      this.senhaVisivel = !this.senhaVisivel
    },
    isEmailValid (email) {
      if (!email) {
        return false
      }
      // Se houver espaços antes ou depois, rejeita
      if (email !== email.trim()) {
        return false
      }
      // Regex simples: texto + '@' + texto + '.' + texto
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    },
    // edit
    EditNew () {
      this.EditView = true
      this.Usuario.cusId = 0
      this.Usuario.cusNome = ''
      this.Usuario.cusEmail = ''
      this.Usuario.cusTelefone = ''
      this.Usuario.cusWhatsapp = ''
      this.Usuario.cusSenha = ''
      this.Usuario.cusDtCadastro = null
      this.Usuario.tusId = ''
      this.Usuario.cusAtivo = ''
      this.Usuario.cusUrlImagem = ''
      this.Usuario.cliId = null
      this.Usuario.admTipoUsuario = { tusId: '' }
      this.Usuario.tpeId = this.User.tpeid == 0 ? null : this.User.tpeid
      this.Usuario.garId = this.User.garid == 0 ? null : this.User.garid
      this.Usuario.pesId = this.User.pesid == 0 ? null : this.User.pesid
      this.TipoPessoaSelected()
    },
    EditGrid (item) {
      this.EditView = true
      if (item.cusId != '') {
        axios.get('/Telas/CadastroUsuarios/GetById/' + item.cusId)
          .then(response => {
            this.Usuario = response.data
            this.TipoUsuario = this.TipoUsuarioGeral.filter(x => x.tpeId == this.Usuario.tpeId)

            if (this.User.garid == 0) {
              this.ListGarantidoras = this.ListGarantidorasGeral
            } else {
              this.ListGarantidoras = this.ListGarantidorasGeral.filter(x => x.garId == this.User.garid)
            }
            if (this.Usuario.garId != null) {
              this.BuscaImobiliarias()
            }
          })
      } else {
        this.TipoPessoaSelected()
      }
    },
    EditCancel () {
      this.EditView = false
    },
    async exportarUsuariosExcel () {
      if (!this.usuariosFiltrados.length) return
      const XLSX = await import('xlsx')
      const dados = this.usuariosFiltrados.map(item => ({
        Id: item.cusId,
        Garantidora: this.nomeAcesso(item),
        Imobiliária: this.nomeImobiliaria(item),
        Nome: item.cusNome,
        Email: item.cusEmail,
        WhatsApp: item.cusWhatsapp,
        'Data de cadastro': this.formattedDate(item.cusDtCadastro),
        Perfil: item.admTipoUsuario?.tusNome || '',
        Situação: item.cusAtivo ? 'Ativo' : 'Inativo'
      }))
      const planilha = XLSX.utils.json_to_sheet(dados)
      const arquivo = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(arquivo, planilha, 'Usuários')
      XLSX.writeFile(arquivo, `usuarios-filtrados-${this.$moment().format('YYYY-MM-DD-HHmm')}.xlsx`)
    },
    async UploadImg (value) {
      const formData = new FormData()
      formData.append('file', value)
      const uploadResult = await axios.post('/Telas/CadastroUsuarios/upload', formData)
      return uploadResult
    },
    buildFileUrl (path) {
      if (!path) return ''
      const rel = String(path).replace(/\\/g, '/') // normaliza separadores
      const base = this.$imgURL
      return `${base}/Telas/CadastroUsuarios/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`
    },
    async Add () {
      if (this.Usuario.tpeId == 1 && this.Usuario.garId === null) {
        this.$mensagemAviso('Garantidora Obrigatório.')
      } else if (this.Usuario.tpeId == 2 && this.Usuario.pesId === null) {
        this.$mensagemAviso('Garantidora Obrigatório.')
      } else if (this.Usuario.tpeId == 2 && this.Usuario.parId === null) {
        this.$mensagemAviso('Parceiro Obrigatório.')
      } else if (this.Usuario.tpeId == 3 && this.Usuario.pesId === null) {
        this.$mensagemAviso('Garantidora Obrigatório.')
      } else if (this.Usuario.tpeId == 3 && this.Usuario.imoId === null) {
        this.$mensagemAviso('Imobiliária Obrigatório.')
      } else if (this.Usuario.admTipoUsuario.tusId === null || this.Usuario.admTipoUsuario.tusId == 0) {
        this.$mensagemAviso('Perfil Usuário Obrigatório.')
      } else if (this.Usuario.cusNome == '') {
        this.$mensagemAviso('Nome Obrigatório.')
      } else if (this.Usuario.cusEmail == '' || this.Usuario.cusEmail === null) {
        this.$mensagemAviso('E-mail Obrigatório.')
      } else if (!this.isEmailValid(this.Usuario.cusEmail)) {
        this.$mensagemAviso('E-mail Inválido.')
      } else if (this.Usuario.cusSenha == '') {
        this.$mensagemAviso('Senha Obrigatória.')
      } else if (this.Usuario.cusAtivo === '') {
        this.$mensagemAviso('Ativo Obrigatório.')
      } else {
        const valida = this.Usuarios.filter(x => x.cusEmail.toLowerCase() == this.Usuario.cusEmail.toLowerCase() && x.cusId != this.Usuario.cusId && x.admTipoUsuario.tusId == this.Usuario.admTipoUsuario.tusId)

        if (valida.length > 0) {
          this.$mensagemAviso('E-mail já cadastrado.')
        } else {
          this.Usuario.cusDtCadastro = moment()
          if (this.Usuario.cusAtivo === '' || this.Usuario.cusAtivo === null) {
            this.Usuario.cusAtivo = true
          }
          if (this.User != '' && this.Usuario.tpeId != '' && this.Usuario.tpeId != null && this.User.garid != 0) {
            this.Usuario.pesId = this.Usuario.pesId
            this.Usuario.garId = this.User.garid
          }
          if ((this.Usuario.tpeId == '' || this.Usuario.tpeId == null) && this.User.garid == 0) {
            this.Usuario.pesId = null
          }
          if (this.User != '' && this.Usuario.tpeId != '' && this.Usuario.tpeId != null && this.Usuario.tpeId != 3 && this.Usuario.tpeId != 2 && this.User.garid == 0) {
            this.Usuario.pesId = this.Usuario.garId
          }
          // console.log('Userlogado')
          // console.log(this.User)
          // console.log('usuario')
          // console.log(this.Usuario)
          if (this.selectedFile != '' && this.selectedFile != null) {
            //  console.log(this.selectedFile[0].size)
            const uploadSuccess = await this.UploadImg(this.selectedFile[0])
            if (uploadSuccess.status == 200) {
              this.Usuario.cusUrlImagem = uploadSuccess.data.nameFile
              this.Usuario.tusId = this.Usuario.admTipoUsuario.tusId
              axios.post('/Telas/CadastroUsuarios/Add', this.Usuario)
                .then(response => {
                  if (response.data > 0) {
                    this.$mensagemAvisoSucesso('Registro Incluído.')
                    this.EnviaEmailCadastro(this.Usuario)
                    this.Get()
                  }
                })
            } else {
              this.$mensagemErro('Não foi possível carregar imagem.')
            }
          } else {
            this.Usuario.cusUrlImagem = ''
            this.Usuario.tusId = this.Usuario.admTipoUsuario.tusId
            if (this.Usuario.cusAtivo === '' || this.Usuario.cusAtivo === null) {
              this.Usuario.cusAtivo = true
            }
            if (this.User != '' && this.Usuario.tpeId != '' && this.Usuario.tpeId != null && this.User.garid != 0) {
              this.Usuario.pesId = this.Usuario.pesId
              this.Usuario.garId = this.User.garid
            }
            if ((this.Usuario.tpeId == '' || this.Usuario.tpeId == null) && this.User.garid == 0) {
              this.Usuario.pesId = null
            }
            if (this.User != '' && this.Usuario.tpeId != '' && this.Usuario.tpeId != null && this.Usuario.tpeId != 3 && this.Usuario.tpeId != 2 && this.User.garid == 0) {
              this.Usuario.pesId = this.Usuario.garId
            }
            axios.post('/Telas/CadastroUsuarios/Add', this.Usuario)
              .then(response => {
                if (response.data > 0) {
                  this.$mensagemAvisoSucesso('Registro Incluído.')
                  this.EnviaEmailCadastro(this.Usuario)
                  this.Get()
                }
              })
          }
        }
      }
    },
    async Put () {
      if (this.Usuario.tpeId == 1 && this.Usuario.garId === null) {
        this.$mensagemAviso('Garantidora Obrigatório.')
      } else if (this.Usuario.tpeId == 2 && this.Usuario.pesId === null) {
        this.$mensagemAviso('Garantidora Obrigatório.')
      } else if (this.Usuario.tpeId == 2 && this.Usuario.parId === null) {
        this.$mensagemAviso('Parceiro Obrigatório.')
      } else if (this.Usuario.tpeId == 3 && this.Usuario.pesId === null) {
        this.$mensagemAviso('Garantidora Obrigatório.')
      } else if (this.Usuario.tpeId == 3 && this.Usuario.imoId === null) {
        this.$mensagemAviso('Imobiliária Obrigatório.')
      } else if (this.Usuario.admTipoUsuario.tusId === null || this.Usuario.admTipoUsuario.tusId == 0) {
        this.$mensagemAviso('Perfil Usuário Obrigatório.')
      } else if (this.Usuario.cusNome == '') {
        this.$mensagemAviso('Nome Obrigatório.')
      } else if (this.Usuario.cusEmail == '' || this.Usuario.cusEmail === null) {
        this.$mensagemAviso('E-mail Obrigatório.')
      } else if (!this.isEmailValid(this.Usuario.cusEmail)) {
        this.$mensagemAviso('E-mail Inválido.')
      } else if (this.Usuario.cusAtivo === '') {
        this.$mensagemAviso('Ativo Obrigatório.')
      } else {
        const valida = this.Usuarios.filter(x => x.cusEmail.toLowerCase() == this.Usuario.cusEmail.toLowerCase() && x.cusId != this.Usuario.cusId && x.admTipoUsuario.tusId == this.Usuario.admTipoUsuario.tusId)

        if (valida.length > 0) {
          this.$mensagemAviso('E-mail já cadastrado.')
        } else {
          if (this.Usuario.cusAtivo === '' || this.Usuario.cusAtivo === null) {
            this.Usuario.cusAtivo = true
          }
          if (this.User != '' && this.Usuario.tpeId != '' && this.Usuario.tpeId != null && this.User.garid != 0) {
            this.Usuario.pesId = this.Usuario.pesId
            this.Usuario.garId = this.User.garid
          }
          if ((this.Usuario.tpeId == '' || this.Usuario.tpeId == null) && this.User.garid == 0) {
            this.Usuario.pesId = null
          }
          if (this.User != '' && this.Usuario.tpeId != '' && this.Usuario.tpeId != null && this.Usuario.tpeId != 3 && this.Usuario.tpeId != 2 && this.User.garid == 0) {
            this.Usuario.pesId = this.Usuario.garId
          }
          if (this.selectedFile != '' && this.selectedFile != null) {
            //  console.log(this.selectedFile[0].size)
            const uploadSuccess = await this.UploadImg(this.selectedFile[0])
            if (uploadSuccess.status == 200) {
              this.Usuario.cusUrlImagem = uploadSuccess.data.nameFile
              this.Usuario.tusId = this.Usuario.admTipoUsuario.tusId
              axios.put('/Telas/CadastroUsuarios/Update', this.Usuario)
                .then(response => {
                  if (response.status == 200) {
                    this.$mensagemAvisoSucesso('Registro Alterado.')
                    this.Get()
                  }
                })
            } else {
              this.$mensagemErro('Não foi possível carregar imagem.')
            }
          } else {
            if (this.Usuario.cusUrlImagem != '') {
              this.Usuario.cusUrlImagem = '0'
            }
            if (this.Usuario.cusAtivo === '' || this.Usuario.cusAtivo === null) {
              this.Usuario.cusAtivo = true
            }
            if (this.User != '' && this.Usuario.tpeId != '' && this.Usuario.tpeId != null && this.User.garid != 0) {
              this.Usuario.pesId = this.Usuario.pesId
              this.Usuario.garId = this.User.garid
            }
            if ((this.Usuario.tpeId == '' || this.Usuario.tpeId == null) && this.User.garid == 0) {
              this.Usuario.pesId = null
            }
            if (this.User != '' && this.Usuario.tpeId != '' && this.Usuario.tpeId != null && this.Usuario.tpeId != 3 && this.Usuario.tpeId != 2 && this.User.garid == 0) {
              this.Usuario.pesId = this.Usuario.garId
            }
            this.Usuario.tusId = this.Usuario.admTipoUsuario.tusId
            axios.put('/Telas/CadastroUsuarios/Update', this.Usuario)
              .then(response => {
                if (response.status == 200) {
                  this.$mensagemAvisoSucesso('Registro Alterado.')
                  this.Get()
                }
              })
          }
        }
      }
    },
    DeleteImagem () {
      this.Usuario.cusUrlImagem = ''
    },
    TipoPessoaSelected () {
      this.ListGarantidoras = []
      this.Usuario.pesId = null
      this.ListParceirosGeral = []
      this.ListImobiliariasGeral = []
      this.ListImobiliarias = []

      if (this.Usuario.tpeId === '' && this.Usuario.tpeId === null) {
        this.TipoUsuario = this.TipoUsuarioGeral.filter(x => x.tpeId === null)
      } else {
        this.Usuario.admTipoUsuario.tusId = null
        this.TipoUsuario = this.TipoUsuarioGeral.filter(x => x.tpeId === this.Usuario.tpeId)

        if (this.User.garid == 0) {
          this.ListGarantidoras = this.ListGarantidorasGeral
        } else {
          this.ListGarantidoras = this.ListGarantidorasGeral.filter(x => x.garId == this.User.garid)

          if (this.User.tpeid == 3) {
            this.Usuario.pesId = this.User.pesid
            this.Usuario.garId = this.User.garid
          } else {
            this.Usuario.pesId = this.User.garid
            this.Usuario.garId = this.User.garid
          }
        }
      }
    },
    EnviaEmailCadastro (usuariocad) {
      axios.get(`/Telas/CadastroUsuarios/GetByIdMensagemPadrao/7?garId=${usuariocad.garId || this.Usuario.garId || this.User.garid || 0}`)
        .then(async response => {
          this.templateEmail = response.data
          const _dadosEmail = {
            nomeDe: '[NomeSistema]',
            nomePara: usuariocad.cusNome,
            assunto: 'Cadastro Usuário - Sistema [NomeSistema]',
            destinatario: usuariocad.cusEmail,
            emailResposta: this.$GarantePayEmail,
            textoEmail: this.templateEmail.mpdTexto
              .replace('[NomeUsuario]', usuariocad.cusNome)
              .replace('[LinkAcesso]', this.$GarantePayLinkAcesso)
              .replace('[UsuarioLogin]', usuariocad.cusEmail)
              .replace('[SenhaAcesso]', usuariocad.cusSenha),
            listAnexos: null // {nomeAnexo: '', anexo: '', tipoAnexo: ''}
          }
          const emailPersonalizado = await personalizarEmailGarantidora(_dadosEmail, usuariocad.garId || this.Usuario.garId || this.User.garid || 0, this.$imgURL, this.$GarantePayLinkAcesso, this.$GarantePayEmail).catch(error => {
            this.$mensagemErro(error.message || 'Não foi possível carregar a identificação da garantidora para o e-mail.')
            return null
          })
          if (!emailPersonalizado) return
          axios.post('/Telas/CadastroUsuarios/Enviamail', emailPersonalizado)
        })
    },
    // edit
    DeleteGrid (item) {
      this.$mensagemConfirma('Tem certeza que deseja excluir?')
        .then((result) => {
          if (result.isConfirmed) {
            // Lógica para excluir o item
            const param1 = item.cusId
            axios.delete(`/Telas/CadastroUsuarios/Delete/${param1}`)
              .then(response => {
                if (response.status == 200) {
                  this.$mensagemAvisoSucesso('Registro Excluido.')
                  this.Get()
                }
              })
          }
        })
    },
    CarregaPermissao (value, tipo) {
      if (tipo == 3) {
        this.TelasImobAcesso.map(element => {
          const Permissoes2 = {
            cusId: value,
            cdtId: parseInt(element.cdtId),
            cusTipo: parseInt(element.cusTipo)
          }
          return axios.post('/Telas/CadastroUsuarios/AddControlePermissoes', Permissoes2)
            .then(response => {
              if (response.data > 0) {
                return null
              }
            })
        })
      } else if (tipo == 4) {
        this.TelasParcAcesso.map(element => {
          const Permissoes2 = {
            cusId: value,
            cdtId: parseInt(element.cdtId),
            cusTipo: parseInt(element.cusTipo)
          }
          return axios.post('/Telas/CadastroUsuarios/AddControlePermissoes', Permissoes2)
            .then(response => {
              if (response.data > 0) {
                return null
              }
            })
        })
      }
    },
    BuscaImobiliarias () {
      this.ListImobiliariasGeral = []
      this.ListImobiliarias = []
      if (this.Usuario.garId === null || this.Usuario.garId === '' || this.Usuario.garId === undefined) {
        this.Usuario.pesId = null
        return
      }
      // this.Usuario.garId = this.Usuario.pesId;
      axios.get('/Telas/CadastroUsuarios/GetByGarIdParIdImobiliarias/' + this.Usuario.garId + '/0')
        .then(response => {
          if (response.data.length > 0) {
            this.ListImobiliariasGeral = response.data.filter(item => !this.ehImobiliaria || (Number(item.imoId) === Number(this.User.pesid) && Number(item.garId) === Number(this.User.garid)))
            this.ListImobiliarias = this.ListImobiliariasGeral
          }
        })
    },
    async Get () {
      this.EditView = false
      await axios.get('/Telas/CadastroUsuarios/GetDados')
        .then(response => {
          this.Usuarios = response.data.cadastroUsuarios
          this.ListGarantidorasGeral = (response.data.garantidoras || []).filter(x => x.garVisivel)
          this.User.garid = response.data.garId
          this.User.tpeid = response.data.tpeId
          this.User.tusid = response.data.tusId
          this.User.pesid = response.data.pesId

          this.TipoUsuarioGeral = response.data.tipoUsuarios.sort((a, b) => {
            const nomeA = a.tusNome || ''
            const nomeB = b.tusNome || ''
            return nomeA.localeCompare(nomeB)
          })

          this.ListImobiliariasGeral = (response.data.listaImobiliarias || []).filter(item => !this.ehImobiliaria || (Number(item.imoId) === Number(this.User.pesid) && Number(item.garId) === Number(this.User.garid)))
          this.ListaImobiliariasFiltro = [...this.ListImobiliariasGeral]
          this.ListParceirosGeral = response.data.listaParceiros

          if (this.User.garid != 0) {
            this.TipoPessoaSelected()
          }

          this.TipoPessoas = response.data.tipoPessoas

          if (this.User.tpeid != null && this.User.tpeid != 0) {
            this.TipoPessoas = this.TipoPessoas.filter(x => x.tpeId === this.User.tpeid)
          }

          if (this.User.garid != 0) this.filtroGarantidora = this.User.garid
          if (this.ehImobiliaria) this.filtroImobiliaria = this.User.pesid

          if (this.id != '' && this.id != null) {
            const _item = { cusId: this.id }
            this.EditGrid(_item)
          }
        })
    }
  },
  created () {
    this.Get()
  }
}
</script>

<style scoped>
.gp-user-page-heading{align-items:center;gap:12px;margin-bottom:20px}.gp-user-page-heading h3{margin:0;color:#102a5a;font-size:14px}.gp-user-page-heading .breadcrumbs{margin:0}
.gp-user-form-header{display:flex;align-items:center;gap:11px;padding:13px 16px;border-bottom:1px solid #e8e1d7;background:#fcf8f2}.gp-user-form-header h4{margin:0;color:#102a5a;font-size:13px;font-weight:800}.gp-user-form-header p{margin:2px 0 0;color:#68748a;font-size:10.5px}.gp-user-form-icon{width:34px;height:34px;display:grid;flex:0 0 34px;place-items:center;border-radius:10px;background:#fff0dd;color:#bd6300}
.card{overflow:hidden;border:1px solid #e1d9cd;border-radius:13px;box-shadow:0 7px 20px rgba(16,42,90,.045)}.card-body .form-group{padding:7px 8px}.card-body .form-group label{margin-bottom:5px;color:#4d586d;font-size:11px;font-weight:750}.card-body .form-control{min-height:38px;border-color:#d8d2c8;border-radius:9px;color:#17223b;font-size:12px}.card-body .form-control:focus{border-color:#1d4f9f;box-shadow:0 0 0 2px rgba(29,79,159,.1)}
.gp-user-main-actions{display:flex;justify-content:flex-end;gap:8px}.gp-user-main-actions .btn{min-width:118px;display:inline-flex;align-items:center;justify-content:center;gap:5px}.gp-user-main-actions .btn-link{min-width:auto}
.gp-user-filters{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));align-items:end;gap:12px;margin-bottom:10px;padding:14px;border:1px solid #e1d9cd;border-left:4px solid #e77900;border-radius:12px;background:#fcf8f2}.gp-user-filter label{display:block;margin-bottom:5px;color:#4d586d;font-size:11px;font-weight:750}.gp-user-filter .form-control{min-height:38px;border-color:#d8d2c8;border-radius:9px;background:#fff;color:#17223b;font-size:12px}.gp-user-filter :deep(.v-field){min-height:38px;border-radius:9px;background:#fff;font-size:12px}.gp-user-filter :deep(.v-field__input){min-height:38px;padding-top:4px;padding-bottom:4px}.gp-user-filter :deep(.v-field__append-inner){min-height:38px;padding-top:7px}.gp-user-clear{min-height:38px}.gp-user-grid-toolbar{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:0 2px 10px;color:#68748a;font-size:11.5px;font-weight:650}.gp-export-button{display:inline-flex;align-items:center;gap:6px;border:1px solid #a9d6bf!important;background:#e7f7ef!important;color:#16724b!important;box-shadow:none!important}.gp-user-status{display:inline-flex;align-items:center;justify-content:center;min-width:58px;padding:3px 8px;border-radius:999px;font-size:9.5px;font-weight:750}.gp-user-status.is-active{background:#e7f7ef;color:#16724b}.gp-user-status.is-inactive{background:#fdebed;color:#b52b3b}
@media(max-width:1199.98px){.gp-user-filters{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:767.98px){.gp-user-page-heading{align-items:flex-start;flex-direction:column}.gp-user-filters{grid-template-columns:1fr}.gp-user-grid-toolbar{align-items:stretch;flex-direction:column}.gp-user-grid-toolbar .btn,.gp-user-main-actions .btn{width:100%}.gp-user-main-actions{flex-direction:column}.gp-user-main-actions .btn-link{width:100%}}
</style>
